<template>
  <v-col lg="3" sm="6" md="7" cols="12">
    <v-card :loading="isLoading" height="100%">
      <v-card-title class="pa-6 pb-3">
        <p>{{ title }}</p>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <v-row no-gutters>
          <v-col cols="6" class="my-auto">
            <span class="" style="font-size: 42px"
              >{{ title_number }}
              <!-- <span v-if="title_percentage > 0" class="caption success--text"
                >+{{ title_percentage }}%</span
              >
              <span
                v-else-if="title_percentage == 0"
                class="caption warning--text"
                >{{ title_percentage }}%</span
              >
              <span v-else class="caption error--text"
                >-{{ title_percentage }}%</span
              > -->
            </span>
          </v-col>
          <v-col cols="6">
            <ApexChart
              height="100"
              type="bar"
              :options="chart_options"
              :series="chart_series"
            ></ApexChart>
          </v-col>
        </v-row>
        <v-row no-gutters class="justify-space-between">
          <div>
            <div class="subtext">
              {{ sub_title_number }}
              <v-icon v-if="sub_title_number > 0" color="success">
                mdi-arrow-top-right</v-icon
              >
              <v-icon v-else-if="sub_title_number < 0" color="error">
                mdi-arrow-bottom-right</v-icon
              >
              <v-icon v-else color="warning"> mdi-arrow-left-right</v-icon>
            </div>
            <div class="subtext-index">
              {{ sub_title_number_text }}
            </div>
          </div>
          <div>
            <div class="subtext">
              {{ sub_title_percentage }}%
              <v-icon v-if="sub_title_percentage > 0" color="success">
                mdi-arrow-top-right</v-icon
              >
              <v-icon v-else-if="sub_title_percentage < 0" color="error">
                mdi-arrow-bottom-right</v-icon
              >
              <v-icon v-else color="warning"> mdi-arrow-left-right</v-icon>
            </div>
            <div class="subtext-index">
              {{ sub_title_percentage_text }}
            </div>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ApexChart from "vue-apexcharts";

@Component({
  components: { ApexChart },
})
export default class DashboardCardBarChart extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly title_number: string;
  @Prop() readonly title_percentage: string;
  @Prop() readonly sub_title_number: string;
  @Prop() readonly sub_title_percentage: string;
  @Prop() readonly chart_options: unknown;
  @Prop() readonly chart_series: unknown;
  @Prop() readonly sub_title_number_text: string;
  @Prop() readonly sub_title_percentage_text: string;
  @Prop() readonly isLoading: boolean;
}
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
